/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { rendererIconByName } from '@gh/common-internal-shared';
import { LayoutBasedGridDefinition } from '@gh/core-ui-grid';

@Injectable()
export class EstimatingSalesTaxRateListTabGridDefinition extends LayoutBasedGridDefinition {
  columnDefs = {
    isDefault: {
      cellRenderer: (params: any): string => params.node.data.isDefault ? rendererIconByName('done') : '',
    },
  };

  options = {
    getRowId: (params) => String(params.data.id),
  };
}
